import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Table,
  Alert,
  Label,
  Input,
} from "reactstrap";
import Papa from "papaparse";
import Steps from "../../../components/Steps/Steps";
import Select from "react-select/lib/Select";
import { BiUpload, BiXCircle } from "react-icons/bi";
import { toastContainer, dismissToast } from "../../../utils/toast";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { stripReplacementChar } from "../../../utils/normalizeText";
import Checkbox from "rc-checkbox";
import WarningModal from "../../../components/Trivvy/WarningModal";
import {formatPhoneNumberForMetaData,orgUserMetaDataKeysLimit,fieldOptions,NO_HEADING_COLUMN_PLACEHOLDER,NO_HEADING_COLUMN_PREFIX,DEACTIVATE_USERS_CONFIRMATION} from "../../../utils/constants.js"
import { useMemo } from "react";
import "./UploadUsersModal.css";

export default function UploadUsersModal({
  open,
  onClose,
  uploadSuccess,
  oldUsers = [],
  oldMatchedKeys,
  columnNames,
  loadingOldUsers = false,
  oldUsersError = false,
  isUserListUpload,
}) {

  console.log("dattta:",oldMatchedKeys)
  const [usersList, setUsersList] = useState([]);
  const [invalidUsersList, setInvalidUsersList] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [file, setFile] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [allUsersMetaData, setAllUsersMetaData] = useState([]);
  const [orgUserMetaData, setOrgUserMetaData] = useState({});
  const [fields, setFields] = useState([]);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [inviteViaEmail, setInviteViaEmail] = useState(false);
  const [inviteViaSMS, setInviteViaSMS] = useState(false);
  const [notifyNewUsers, setNotifyNewUsers] = useState(false);
  const [notifyAllUsers, setNotifyAllUsers] = useState(false);
  const [phoneValuesPresent, setPhoneValuesPresent] = useState(false);
  const [uploadType, setUploadType] = useState("uploadAndUpdate");
  const [uploadOnly, setUploadOnly] = useState(false);
  const [uploadAndUpdate, setUploadAndUpdate] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [deactivateOldNonCsvUsers, setDeactivateOldNonCsvUsers] = useState(
    false
  );
  const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
  const [isDateSampleData, setIsDateSampleData] = useState([]);
  const [isDateResponse, setIsDateResponse] = useState([]);
  const [wrongDateColumns, setWrongDateColumns] = useState([]);
  const [isEmailPresent, setIsEmailPresent] = useState(true);
  const [firstMatchedKey, setFirstMatchedKey] = useState("");
  const [invalidFileExtension, setInvalidFileExtension] = useState(false);
  const [currentCSVHeader,setCurrentCSVHeaders]=useState([])
  const [includedColumns, setIncludedColumns] = useState({});
  // let phoneValuesPresent =
  //   usersList && usersList.length
  //     ? usersList.filter((x) => x.mobileNumber).length > 0
  //     : false;

  const emailValuesPresent =
    usersList && usersList.length
      ? usersList.filter((x) => x.email).length > 0
      : false;

  const [notificationType, setNotificationType] = useState("");

  
  const [matchedKeys, setmatchedKeys] = useState([]);

   
  
  const handleCsvParseComplete = (result, file) => {
    const phoneKeys = [
      "phone","phone_number","phonenumber","ph no","ph_no",
      "mobile","mobile_number","mobile number","mobilenumber",
      "contact","contact_number","contact number","contactnumber",
      "cell","cell_number","cellphone","mobileNumber"
    ];
    const normalizedPhoneKeysSet = new Set(
      phoneKeys.map(k => k.toLowerCase().replace(/\s|_/g, ""))
    );
  
    // const originalFields = result.meta.fields;
    const originalFields = (result.meta.fields || []).map(h =>
         String(h || "").replace(/^\uFEFF/, "").trim()
    );


    const data = result.data;
    // if (!originalFields || !data || !data.length) return;
    if (!originalFields.length || !data || !data.length) {
       toastContainer("The CSV appears empty or has no header row.", "error");
       return;
     }
  
    // Keep a column when it has a heading OR has at least some data anywhere.
    // Only drop columns that have NO heading AND NO data (genuinely-empty trailing columns).
    // Track the source column index so blank/duplicate headers stay addressable.
    const fieldMetaList = [];
    for (let i = 0; i < originalFields.length; i++) {
      const field = originalFields[i];
      const hasHeading = field != null && field.trim() !== "";
      const hasData = data.some(row => row[field] != null && String(row[field]).trim() !== "");
      if (!hasHeading && !hasData) continue;
      fieldMetaList.push({ original: hasHeading ? field : "", sourceIndex: i });
    }

    // Initialize per-column arrays keyed by source index (blank headers can collide on name)
    const fieldDataMap = {};
    for (let i = 0; i < fieldMetaList.length; i++) {
      fieldDataMap[fieldMetaList[i].sourceIndex] = [];
    }

    // IMPORTANT: push a value for EVERY ROW (even empty => "")
    for (let i = 0; i < data.length; i++) {
      const user = data[i];
      for (let j = 0; j < fieldMetaList.length; j++) {
        const original = fieldMetaList[j].original;
        const sourceIndex = fieldMetaList[j].sourceIndex;

        let trimmedValue = user[original] == null ? "" : String(user[original]).trim();

        // Only coerce to number for non-phone, non-empty pure numerics
        // if (!isPhoneLike && trimmedValue !== "" && !isNaN(trimmedValue)) {
        //   trimmedValue = Number(trimmedValue);
        // }

        // ⬇️ always push, even when trimmedValue === ""
        fieldDataMap[sourceIndex].push(trimmedValue);
      }
    }

    // Duplicated in matchedKeys and handleCsvParseComplete
    // setPhoneValuesPresent(
    //   originalFields.some(field =>
    //     normalizedPhoneKeysSet.has(field.toLowerCase().replace(/\s|_/g, ""))
    //   )
    // );

    // fieldName is the empty string for a no-heading column so the Match-step
    // header render can detect it and show an editable input instead of a label.
    const newData = fieldMetaList.map(fieldMeta => ({
      selectedKey: "",
      fieldName: fieldMeta.original,
      noHeading: fieldMeta.original === "",
      data: fieldDataMap[fieldMeta.sourceIndex],
    }));

    setRowData(newData);
  };




  
  
  

  // console.log(oldUsers);

  const handleFileUpload = (e) => {
    const csvFile = e.target.files[0];
  
    setUsersList([]);
    setInvalidUsersList([]);
    setRowData([]);
    setmatchedKeys([]);
    setInvalidFileExtension(false);
    setIncludedColumns({});
  
    if (!csvFile) {
      setFile(null);
      return;
    }
  
    // Validate file extension
    const fileName = csvFile.name.toLowerCase();
    const isValidCsv = fileName.endsWith(".csv");
    if (!isValidCsv) {
      setInvalidFileExtension(true);
      setFile(csvFile);
      return;
    }
  
    setFile(csvFile);
  
    // bug730: read the file ourselves so we can auto-detect a non-UTF-8 export. Papa.parse
    // on a raw File decodes as UTF-8, so a Latin-1/Windows-1252 CSV (Excel's default export)
    // turns "\u00E9" (byte 0xE9) into U+FFFD ("\uFFFD") and permanently loses accents like in "Jos\u00E9".
    // Try UTF-8 first; if it produced replacement chars, re-decode as Windows-1252.
    const parseCsvText = (csvText) => {
      Papa.parse(csvText, {
        header: true,
        dynamicTyping: false,          // keep phones/IDs as strings
        skipEmptyLines: "greedy",
        worker: false,                 // avoids "window is not defined" in worker
        transformHeader: function (h) {
          const s = h == null ? "" : h;  // no ??
          return String(s).replace(/^\uFEFF/, "").trim();
        },
        complete: function (res) {
          console.log("CSV headers:", res.meta && res.meta.fields);
          console.log("CSV rows:", Array.isArray(res.data) ? res.data.length : 0);
          handleCsvParseComplete(res, csvFile);
        },
        error: function (err) {
          console.error("Papa parse error:", err);
          toastContainer("Failed to read the CSV. Please try again.", "error");
        },
      });
    };

    const utf8Reader = new FileReader();
    utf8Reader.onload = () => {
      const utf8Text = utf8Reader.result ? String(utf8Reader.result) : "";
      if (utf8Text.indexOf("\uFFFD") === -1) {
        // Clean UTF-8 (no replacement chars) \u2014 use it as-is.
        parseCsvText(utf8Text);
        return;
      }
      // Replacement chars present \u2192 almost certainly a Windows-1252/Latin-1 export.
      // Re-decode in that charset so accented names survive.
      const latin1Reader = new FileReader();
      latin1Reader.onload = () => {
        const latin1Text = latin1Reader.result ? String(latin1Reader.result) : "";
        parseCsvText(latin1Text || utf8Text);
      };
      latin1Reader.onerror = () => parseCsvText(utf8Text);
      latin1Reader.readAsText(csvFile, "windows-1252");
    };
    utf8Reader.onerror = () => {
      console.error("Papa parse error: failed to read file");
      toastContainer("Failed to read the CSV. Please try again.", "error");
    };
    utf8Reader.readAsText(csvFile, "utf-8");
  };
  
  

  // Define possible key variations
  const emailKeys = ["email", "Email", "e-mail", "eMail"];
  const employeeIdKeys = ["employeeId", "employeeID", "empId", "empID"];
  const phoneKeys = [
    "phone",
    "phoneNumber",
    "mobile",
    "mobileNumber",
    "contactNumber",
  ];
  const firstNameKeys = ["firstName", "FirstName", "first_name"];
  const lastNameKeys = ["lastName", "LastName", "last_name"];
  const hasEmail = matchedKeys.some((key) => emailKeys.includes(key));
  const hasEmployeeId = matchedKeys.some((key) => employeeIdKeys.includes(key));
  const hasPhone = matchedKeys.some((key) => phoneKeys.includes(key));

const mapTableData = () => {
  const findFirstMatchedKey = () => {
    const allPossibleKeys = [].concat(emailKeys, employeeIdKeys, phoneKeys);
    return allPossibleKeys.find(function(key) {
      return rowData.some(function(x) {
        return x.selectedKey === key;
      });
    });
  };

  const firstMatchedKey = findFirstMatchedKey();
  setFirstMatchedKey(firstMatchedKey);

  const emailKey = emailKeys.find(function(key) {
    return rowData.some(function(x) {
      return x.selectedKey === key;
    });
  });

  const employeeIdKey = employeeIdKeys.find(function(key) {
    return rowData.some(function(x) {
      return x.selectedKey === key;
    });
  });

  const phoneKey = phoneKeys.find(function(key) {
    return rowData.some(function(x) {
      return x.selectedKey === key;
    });
  });

  const firstNameKey = firstNameKeys.find(function(key) {
    return rowData.some(function(x) {
      return x.selectedKey === key;
    });
  });

  const lastNameKey = lastNameKeys.find(function(key) {
    return rowData.some(function(x) {
      return x.selectedKey === key;
    });
  });

  const data = rowData.filter(function(x) {
    return []
      .concat(emailKeys, employeeIdKeys, phoneKeys, firstNameKeys, lastNameKeys)
      .includes(x.selectedKey);
  });

  const emailObj =
    emailKey &&
    data.find(function(x) {
      return x.selectedKey === emailKey;
    });

  const mobileNumberObj =
    phoneKey &&
    data.find(function(x) {
      return x.selectedKey === phoneKey;
    });

  const employeeIdObj =
    employeeIdKey &&
    data.find(function(x) {
      return x.selectedKey === employeeIdKey;
    });

  const firstNameObj =
    firstNameKey &&
    data.find(function(x) {
      return x.selectedKey === firstNameKey;
    });

  const lastNameObj =
    lastNameKey &&
    data.find(function(x) {
      return x.selectedKey === lastNameKey;
    });

    
  const primaryData = emailObj || mobileNumberObj || employeeIdObj;
  if (!primaryData) {
    setInvalidUsersList([]);
    setUsersList([]);
    toastContainer(
      "No valid identifier fields found (email, mobile number, or employee ID required)",
      "error"
    );
    return;
  }


  const rowCount =
    rowData.length && rowData[0].data && rowData[0].data.length
      ? rowData[0].data.length
      : 0;

  const users = [];
  

  for (let index = 0; index < rowCount; index++) {
    const email =
      emailObj &&
      emailObj.data[index] &&
      emailObj.data[index].toString().trim();

    let mobileNumber =
      mobileNumberObj &&
      mobileNumberObj.data[index] &&
      mobileNumberObj.data[index].toString().trim();

    if (mobileNumber) {
      mobileNumber = formatPhoneNumberForMetaData(mobileNumber);
    }

    const employeeId =
      employeeIdObj &&
      employeeIdObj.data[index] &&
      employeeIdObj.data[index].toString().trim();

    const firstName =
      firstNameObj &&
      firstNameObj.data[index] &&
      stripReplacementChar(firstNameObj.data[index].toString().trim());

    const lastName =
      lastNameObj &&
      lastNameObj.data[index] &&
      stripReplacementChar(lastNameObj.data[index].toString().trim());

    const user = {
      email: email,
      mobileNumber: mobileNumber,
      role: "User",
      employeeId: employeeId,
      firstName: firstName,
      lastName: lastName,
    };

    // Attach opted-in unmatched column values so Step 3 preview can render them.
    rowData.forEach(function (row) {
      const isMatched = row.selectedKey && row.selectedKey !== "";
      if (!isMatched && includedColumns[row.fieldName] === true) {
        const raw = row.data[index];
        user[row.fieldName] = raw == null ? "" : String(raw).trim();
      }
    });

    users.push(user);
  }

  const cleanedData = users.filter(function (x) {
    const hasAnyUnique = !!(x.email || x.employeeId || x.mobileNumber);
    // keep the row if it has at least one unique; do NOT filter on email validity here
    return hasAnyUnique;
  });
  
  const invalidData = users.filter(function (x) {
    const hasAnyUnique = !!(x.email || x.employeeId || x.mobileNumber);
    // save ONLY rows missing all three uniques
    return !hasAnyUnique;
  });

  setUsersList(cleanedData);
  setInvalidUsersList(invalidData);

  // Call API to tag users as new or existing
  const usersToCheck = cleanedData.map(u => ({
    email: u.email,
    phoneNumber: u.mobileNumber,
    employeeId: u.employeeId,
    firstName: u.firstName,
    lastName: u.lastName,
  }));

  axios.post(url.tagUsersIsNew, { users: usersToCheck })
    .then(response => {
      const taggedUsers = response.data.users;
      const updatedUsers = cleanedData.map((u, i) => ({ ...u, isNew: taggedUsers[i].isNew }));
      setUsersList(updatedUsers);

      // Proceed with metadata setup and date verification
      // Blank headings get a positional "Column N" fallback, computed over the
      // FULL rowData so the number matches the CSV's real column position.
      const effectiveFieldNames = rowData.map(function (row, index) {
        const name = row.fieldName == null ? "" : String(row.fieldName).trim();
        return name !== "" ? row.fieldName : `${NO_HEADING_COLUMN_PREFIX} ${index + 1}`;
      });

      // Drop unmatched columns the admin did not opt to include.
      // Matched columns (selectedKey is set) always pass through.
      const includedIndexes = [];
      const filteredRowData = rowData.filter(function (row, index) {
        const isMatched = row.selectedKey && row.selectedKey !== "";
        const keep = isMatched || includedColumns[row.fieldName] === true;
        if (keep) includedIndexes.push(index);
        return keep;
      });

      // Names re-indexed onto the filtered subset so j lines up in both loops.
      const filteredFieldNames = includedIndexes.map(function (index) {
        return effectiveFieldNames[index];
      });

      const allUsersMetaData = [];
  for (let i = 0; i < rowCount; i++) {
    const metaData = [];

    for (let j = 0; j < filteredRowData.length; j++) {
      const row = filteredRowData[j];
      const key = row.selectedKey || filteredFieldNames[j];
      let value = row.data[i];

      if (value != null && String(value).trim() !== "") {
        // bug730: strip any residual replacement char (�) here too — the user-list CSV
        // download rebuilds firstName from this metaData copy, not the top-level field,
        // so cleaning only the top-level firstName/lastName misses the exported value.
        value = stripReplacementChar(String(value));
        if (key === "mobileNumber") {
          value = formatPhoneNumberForMetaData(value);
        }

        metaData.push({ key: key, value: value });
      }
    }

    allUsersMetaData.push({ metaData: metaData });
  }
  setAllUsersMetaData(allUsersMetaData);

  setOrgUserMetaData({
    columnNames: filteredFieldNames.slice(0, orgUserMetaDataKeysLimit),
    columnMetadata: {},
    // numUsers: users.length,
    numUsers: cleanedData.length,
  });

  const isDateTempSampleData = filteredRowData
    .slice(0, orgUserMetaDataKeysLimit)
    .map(function(row, i) {
      // Look up the existing date flag by fieldName so it stays correct
      // after unmatched/unchecked columns are filtered out (otherwise
      // index drift would associate the date flag with the wrong column).
      const existing = isDateSampleData.find(function(d) {
        return d && d.fieldName === row.fieldName;
      });

      return {
        fieldName: filteredFieldNames[i],
        isDate: existing ? existing.isDate : false,
        sampleData: row.data[0] || "",
      };
    });

  setIsDateSampleData(isDateTempSampleData);

  axios
    .post(url.verifyDateFormatFromCSV, isDateTempSampleData)
    .then(function(response) {
      const res = response.data && response.data.data;
      console.log("saved keys:", res.results)
      if (res && res.results) {
        setIsDateResponse(res.results);
        setCurrentCSVHeaders(res.results)
        setIsEmailPresent(res.isEmailPresent);

        if (res.allDateFormatsValid) {
          dismissToast();
          setIsPhoneValid(true);
          setCurrentStep(currentStep + 1);
        } else {
          setWrongDateColumns(res.wrongDateColumns || []);
          setIsPhoneValid(res.isPhoneValid);

          const messages = [];

          if (res.wrongDateColumns && res.wrongDateColumns.length) {
            const columns = res.wrongDateColumns
              .map(function(d) {
                return d.fieldName;
              })
              .join(", ");
            messages.push(
              "Please check the date format in the following columns (should be MM/DD/YYYY): " +
                columns
            );
          }

          if (messages.length) {
            toastContainer(messages.join(". "), "error");
          }
        }
      }
    })
    .catch(function(err) {
      console.error("Upload Error:", err);
    });
    })
    .catch(err => {
      console.error('Error tagging users:', err);
      // Proceed without tagging, or handle error
    });
};



  const handleUploadUsers = () => {
    const formData = new FormData();

    formData.append("file", file); // CSV file
    formData.append(
      "payload",
      JSON.stringify({
        ...orgUserMetaData, // includes columnNames, columnMetadata, numUsers
        isDateResponse,
        matchedKeys,
        data: usersList,
        inviteViaEmail,
        inviteViaSMS,
        notifyNewUsers,
        notifyAllUsers,
        uploadOnly,
        uploadAndUpdate,
        allUsersMetaData,
        isEmailPresent,
        firstMatchedKey,
        deactivateOldNonCsvUsers,
        isPhoneValid,
      })
    );

    axios
      .post(url.uploadUsersForTrivvyFromCsv, formData)
      .then((response) => {
        const res = response.data && response.data.data || {};
        const { success, isDate = [], stats = {} } = res;
        

        const {
          failed = 0,
          inserted = 0,
          matched = 0,
          totalReceived = 0,
          bulkFailed=0,
          adminUpdateFailedCount=0,
          crossOrgCount = 0,
          droppedPhoneCount = 0,
          notified = 0
        } = stats;

        // Prepare toast message
        if (success) {
          const parts = [];

          // Single source for the dropped-phone notice so both toast variants
          // (the joined `parts` string and the Users-List `lines` block) stay in
          // sync. Empty string means there's nothing to report.
          let droppedPhoneMessage = "";
          if (droppedPhoneCount > 0) {
            droppedPhoneMessage = `${droppedPhoneCount} phone number${
              droppedPhoneCount > 1 ? "s" : ""
            } could not be uploaded and need${
              droppedPhoneCount > 1 ? "" : "s"
            } to be checked`;
          }

          if (inserted > 0) {
            parts.push(
              `${inserted} new user${
                inserted > 1 ? "s" : ""
              } uploaded successfully`
            );
          }
          if (bulkFailed > 0) {
            parts.push(
              `${bulkFailed} user${
                bulkFailed > 1 ? "s" : ""
              } with the same unique identifiers already exists in your or another organization and cannot be uploaded or updated`
            );
          }

          if (matched > 0) {
            parts.push(
              `${matched} user${
                matched > 1 ? "s" : ""
              } matched with existing users and ${matched > 1 ? "were" : "was"} updated`
            );
          }

          if (failed > 0) {
            parts.push(
              `${failed} user${failed > 1 ? "s" : ""} with the same unique identifiers already exists in your or another organization and can only be updated`
            );
          }
          if (adminUpdateFailedCount > 0) {
            parts.push(
              `${adminUpdateFailedCount} admin user${adminUpdateFailedCount > 1 ? "s" : ""} cannot be updated without an email`
            );
          }

          if (droppedPhoneMessage) {
            parts.push(droppedPhoneMessage);
          }

          const toastText = (
            <div>
              Total received: {totalReceived}.<br />
              {parts.join(", ")}.<br />
              Total Notified: {notified}.
            </div>
          );
          const toastType = inserted > 0 || matched > 0 ? "success" : "error";

          // TBV-279 (per CEO): in the Users List member-upload context the
          // ticket-mandated wording REPLACES the old descriptive text before
          // "Total received". The unique "new users uploaded" line is kept (it
          // isn't redundant with anything); the matched / cross-org clauses are
          // expressed only via the clearer ticket wording. Every other caller of
          // this modal keeps the original single-line toast unchanged.
          if (isUserListUpload) {
            const lines = [];
            lines.push(`Total received: ${totalReceived}.`);
            if (inserted > 0) {
              lines.push(
                `${inserted} new user${inserted > 1 ? "s" : ""} uploaded successfully.`
              );
            }
            if (matched > 0) {
              lines.push(
                `${matched} User(s) with the same unique identifier exist in your account and have been updated.`
              );
            }
            if (crossOrgCount > 0) {
              lines.push(
                `${crossOrgCount} User(s) with the same unique identifier exist in another organization's account and can not be uploaded or updated by you.`
              );
            }
            if (droppedPhoneMessage) {
              lines.push(`${droppedPhoneMessage}.`);
            }
            lines.push(`Total Notified: ${notified}.`);

            toastContainer(
              <div>
                {lines.map((line, idx) => (
                  <div key={idx} className={idx > 0 ? "mt-1" : ""}>
                    {line}
                  </div>
                ))}
              </div>,
              toastType
            );
          } else {
            toastContainer(toastText, toastType);
          }
        } else {
          toastContainer("Users Upload failed", "error");
        }


        uploadSuccess();
        onClose();
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errors.message &&
          err.response.data.errors.error &&
          (Array.isArray(err.response.data.errors.error) ||
            typeof err.response.data.errors.error === "string")
        ) {
          const first =
            typeof err.response.data.errors.error === "string"
              ? err.response.data.errors.error
              : err.response.data.errors.error.join(", ");
          const message = `${first} ${err.response.data.errors.message}`;
          toastContainer(message, "error");
        } else {
          toastContainer("User with one of the same unique identifier already exists in your or another organization.", "error");
        }
      });
  };



  const buttonDisabled = () => {
    let disabled = false;

    if (currentStep == 1) {
      console.log(file);
      if (!file || invalidFileExtension) {
        disabled = true;
      }
    } else if (currentStep == 2) {
    
    
      if (!hasEmail && !hasEmployeeId && !hasPhone) {
        disabled = true;
      }
    } else if (currentStep == 3) {
      if (notifyAllUsers || notifyNewUsers) {
        if (inviteViaEmail || inviteViaSMS) {
        } else {
          disabled = true;
        }
      }
    }

    return disabled;
  };

  const getFieldNameFromKey = (key) => {
    const keyData = fieldOptions.find((x) => x.value == key);

    if (keyData) {
      return keyData.label;
    } else {
      return null;
    }
  };

  useEffect(() => {
    const currentKeys = rowData.map((x) => x.selectedKey);
    console.log("current keys:",currentKeys,rowData)
    const matched = [...matchedKeys].filter((x) => currentKeys.includes(x));
    setmatchedKeys(matched);
  }, [rowData]);

  useEffect(() => {
    setPhoneValuesPresent(matchedKeys.includes("mobileNumber"));
  }, [matchedKeys]);

  useEffect(() => {
    if (!open) {
      setInvalidFileExtension(false);
      setFile(null);
      setCurrentStep(1);
      setIncludedColumns({});
    }
  }, [open]);

  const newCount = () => {
    let count = 0;

    if (usersList.length) {
      for (const item of usersList) {
        if (item.isNew) {
          count += 1;
        }
      }
    }

    return count;
  };


  const idOf = (obj, key) =>
    obj && typeof obj[key] === "string" ? obj[key].trim() : "";
  
  const oldById = useMemo(() => {
    if (!firstMatchedKey) return new Map();
    const m = new Map();
    for (const u of oldUsers) {
      const id = idOf(u, firstMatchedKey);
      if (id) m.set(id, u);
    }
    return m;
  }, [oldUsers, firstMatchedKey]);

  // Count of existing users who would actually be deactivated on submit.
  // Mirrors the backend matcher in userController.uploadMembersForTrivvyFromCsv
  // (re-confirmed on trivvy-qa-tmp-release-1.3): the BE treats an existing user
  // as "in the CSV" when ANY of their email / employeeId / mobileNumber matches
  // a CSV row (each normalized with trim().toLowerCase()), and only deactivates
  // ACTIVE, non-orgAdmin users (other than the uploader — who is an orgAdmin, so
  // excluding orgAdmins also excludes self). The previous email-only match
  // over-counted everyone the BE matches by employeeId, so the dialog kept
  // showing a phantom number that never cleared after re-uploading.
  const deactivateCount = useMemo(() => {
    const normalizeId = (val) =>
      val === null || val === undefined ? "" : String(val).trim().toLowerCase();

    const csvEmails = new Set();
    const csvEmployeeIds = new Set();
    const csvMobiles = new Set();
    for (const u of usersList) {
      const email = normalizeId(u.email);
      const employeeId = normalizeId(u.employeeId);
      const mobile = normalizeId(u.mobileNumber);
      if (email) csvEmails.add(email);
      if (employeeId) csvEmployeeIds.add(employeeId);
      if (mobile) csvMobiles.add(mobile);
    }

    // Data-not-ready guard: if the CSV has not produced any identifiers yet,
    // do not treat every existing user as unmatched (this was the transient
    // "deleting 88 users" the count used to flash before the rows settled).
    if (
      csvEmails.size === 0 &&
      csvEmployeeIds.size === 0 &&
      csvMobiles.size === 0
    ) {
      return 0;
    }

    let count = 0;
    for (const ou of oldUsers) {
      if (ou.status !== "ACTIVE") continue;
      if (ou.orgAdmin === true) continue;
      const email = normalizeId(ou.email);
      const employeeId = normalizeId(ou.employeeId);
      const mobile = normalizeId(ou.mobileNumber);
      const matched =
        (email && csvEmails.has(email)) ||
        (employeeId && csvEmployeeIds.has(employeeId)) ||
        (mobile && csvMobiles.has(mobile));
      if (!matched) {
        count += 1;
      }
    }
    return count;
  }, [oldUsers, usersList]);

  const getWarningText = () => {
    const uploadCount = usersList.length;
    // Count only the fields that will actually be uploaded — matched columns plus
    // unmatched ones the admin ticked "Include in upload" — capped at the stored
    // limit, so this matches the preview table and the saved metadata (not every
    // parsed CSV column).
    const fieldCount = Math.min(
      rowData.filter(function (row) {
        const isMatched = row.selectedKey && row.selectedKey !== "";
        return isMatched || includedColumns[row.fieldName] === true;
      }).length,
      orgUserMetaDataKeysLimit
    );
  
    // If no unique key is chosen yet, just show the base count.
    if (!firstMatchedKey) {
      return `${uploadCount} user(s) with a total of ${fieldCount} field(s) will be uploaded.`;
    }
  
    // How many will be notified (new vs. unactivated)
    const totalUsersToNotify = notifyAllUsers
      ? usersList.length
      : usersList.filter((u) => u.isNew).length;
  
    let smsInvites = 0;
    let emailInvites = 0;
  
    if (inviteViaEmail || inviteViaSMS) {
      for (const user of usersList) {
        const id = idOf(user, firstMatchedKey);
        const old = oldById.get(id);
        const isNew = user.isNew;
        const isLoggedIn = old ? !!old.isPasswordChanged : false;

        const shouldNotify =
          (notifyNewUsers && isNew) ||
          (notifyAllUsers && !isLoggedIn);

        if (shouldNotify) {
          if (inviteViaSMS && user.mobileNumber) smsInvites += 1;
          if (inviteViaEmail) emailInvites += 1;
        }
      }
    }
  
    const parts = [`${uploadCount} user(s) with a total of ${fieldCount} field(s) will be uploaded.`];
  
    if (smsInvites > 0 || emailInvites > 0) {
      parts.push(
        notifyNewUsers
          ? "Only new users will be notified:"
          : "All unactivated users will be notified:"
      );
    }
  
    if (smsInvites > 0) {
      parts.push(
        `${totalUsersToNotify > 0 && smsInvites === totalUsersToNotify ? "all" : smsInvites
        } will receive SMS text${emailInvites > 0 ? " and" : "."}`
      );
    }
  
    if (emailInvites > 0) {
      parts.push(
        `${totalUsersToNotify > 0 && emailInvites === totalUsersToNotify ? "all" : emailInvites
        } will receive an email.`
      );
    }
  
    return parts.join(" ");
  };
  

  const handleRadioChange = (e) => {
    setNotificationType(e.target.value);
    if (e.target.value === "notifyAllUsers") {
      setNotifyAllUsers(true);
      setNotifyNewUsers(false);
    } else if (e.target.value === "notifyNewUsers") {
      setNotifyAllUsers(false);
      setNotifyNewUsers(true);
    } else {
      setNotifyAllUsers(false);
      setNotifyNewUsers(false);
    }
  };

  const handleRadioChangeForUploadType = (e) => {
    setUploadType(e.target.value);
    if (e.target.value === "uploadOnly") {
      setUploadOnly(true);
      setUploadAndUpdate(false);
    } else if (e.target.value === "uploadAndUpdate") {
      setUploadOnly(false);
      setUploadAndUpdate(true);
    }
  };

const isEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((val, i) => val === sorted2[i]);
};


  const handleDateFieldCheck = (e, fieldName) => {
    // Look up by fieldName so the toggle stays correct after mapTableData
    // compacts isDateSampleData (which drops unmatched + unchecked columns).
    const checked = e.target.checked;
    const tempSampleData = [...isDateSampleData];
    const existingIdx = tempSampleData.findIndex(function (d) {
      return d && d.fieldName === fieldName;
    });

    if (existingIdx >= 0) {
      tempSampleData[existingIdx] = {
        ...tempSampleData[existingIdx],
        isDate: checked,
      };
    } else {
      tempSampleData.push({ fieldName: fieldName, isDate: checked, sampleData: "" });
    }

    setIsDateSampleData(tempSampleData);
  };
 
  const fieldLabelsMap = {
    employeeId: "Employee ID",
    mobileNumber: "Mobile Number",
    lastName: "Last Name",
    firstName: "First Name",
    email: "Email",
  };
const corrections = {
    employetype: "Employee Type",
    employeetype: "Employee Type",
    employmenttype: "Employment Type",
    EmploymentType:"Employment Type",
    phonenumber: "Phone Number",
   // "employeeid": "Employee ID",
   // "empid": "Employee ID",
    dob: "DOB",
    Gender:"Gender",
    Department:'Department',
    JobTitle:'Job Title'
  };
  // const formatKeysForDisplay = (keys) => {
  //   return keys.map((key) => fieldLabelsMap[key] || key);
  // };

function normalize(field) {
    return field.toLowerCase().replace(/\s+/g, '');
}

// function getMissingFields(lastFields, currentFields) {

//     // Normalize the field names
//     const normalizedLastFields = lastFields.map(normalize);
//     const normalizedCurrentFields = currentFields.map(normalize);

//     // Find fields in lastSelectedFields that aren't in currentSelectedFields
//     const missingFields = lastFields.filter(field => 
//         !normalizedCurrentFields.includes(normalize(field))
//     );

//     return missingFields;
// }

function findMissingFields(oldData, newData) {
  // Create a set of normalized field names from newData
  const newFieldsSet = new Set(
    newData.map(item => 
      item.fieldName.toLowerCase().replace(/\s+/g, '')
    )
  );

  // Filter oldData to find fields missing in newData
  const missingFields = oldData.filter(field => {
    const normalizedField = field.toLowerCase().replace(/\s+/g, '');
    return !newFieldsSet.has(normalizedField);
  });

  return missingFields;
}
  const missingFields = findMissingFields(columnNames,[...rowData] );

  const missingLabel = missingFields.length>0?missingFields.map(field =>fieldLabelsMap[field]? fieldLabelsMap[field]:corrections[field] ):[];



  const PREVIEW_LIMIT = 100; // or use react-window for true virtualization


  return (
    <Modal isOpen={open} className="trivvyUsersUpload-modal-container">
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Upload Users
      </ModalHeader>
      <ModalBody className="p-3 pb-0 trivvyUsersUpload">
        <Steps
          steps={["Upload File", "Match Columns", "Preview And Save"]}
          currentStep={currentStep}
        />

        {currentStep === 1 ? (
          <div className="upload-step1">
            <h6 className="mb-3">{file ? file.name : ""}</h6>
            {invalidFileExtension && (
              <Alert color="danger" className="mb-3">
                <BiXCircle className="mr-1" />
                Invalid file type. Please select a CSV file only.
              </Alert>
            )}
            <div className="singleTaskUploadModalBtn">
              <label
                htmlFor="profile-pic-file-input"
                style={{ marginBottom: "0px" }}
              >
                <span
                  className={`actionsByStatus ${
                    1 == 1 ? "" : "singleTaskUpload"
                  } btn-info`}
                >
                  {/* SVG icon — replaces the previous flaticon-upload glyph,
                      which was rendering with its top edge clipped because
                      the icon font's vertical metrics overflowed the button's
                      tight (5px) padding. SVG sits cleanly on the baseline. */}
                  <BiUpload className="mr-1" />
                  Choose File
                </span>
                <small>(Only .csv files, maximum 20MB file size)</small>
              </label>
              <input
                id="profile-pic-file-input"
                onChange={handleFileUpload}
                type="file"
                accept=".csv,text/csv,application/vnd.ms-excel"
              />
            </div>

            <div style={{ fontSize: "12px", marginTop: "12px" }}>
              Easily upload any .csv file with up to 50 unique fields. No
              template is needed. Please just make sure that:
              <ul className="pl-4 mt-2 mb-0">
                <li>
                  Your file includes at least one of the following 3 required
                  fields: <b>Email</b>, <b>Mobile Number</b> or{" "}
                  <b>Employee ID</b>.
                </li>
                <li>
                  The first row of your file contains clear{" "}
                  <b>headers or column names</b>.
                </li>
                <li>
                  Dates are in <b>MM/DD/YYYY</b> format.
                </li>
                <li>
                  Mobile numbers can include spaces, dashes, or parentheses —
                  we'll format them automatically. Add a <b>+</b> and country
                  code for non-US numbers (e.g., +447911123456); US is assumed
                  otherwise.
                </li>
              </ul>
            </div>

            <div
              style={{ fontSize: "12px", marginTop: "24px" }}
              className="text-danger"
            >
              NOTE - Please upload only the minimum number of Personally Identifiable Information (PII) based on  business needs.
            </div>
          </div>
        ) : currentStep === 2 ? (
          <div>
            <div className="my-3">{matchedKeys.length} columns matched.</div>

            {!hasEmail && !hasPhone && !hasEmployeeId && (
              <div className="my-3">
                Please match at least one of the following: Email, Mobile Number
                or Employee ID.
              </div>
            )}
            <div className="my-3">
              Please check the additional columns you would like to load.
            </div>
            {!hasEmail && !hasPhone && (
              <div className="my-3">
                NOTE - To share via email or mobile number, please match the corresponding column.
              </div>
            )}
            <div className="data-mapping-table">
              <div className="data-mapping-table-upload-row">
                {rowData.map((row, index) => {
                  const matched = matchedKeys.includes(row.selectedKey);

                  const hasHeading = row.fieldName != null && String(row.fieldName).trim() !== "";
                  // Gate on the persistent no-heading flag, NOT hasHeading — otherwise
                  // typing the first character makes hasHeading true and the input
                  // swaps to a static label mid-type (focus lost after one char).
                  const showHeadingInput = !getFieldNameFromKey(row.selectedKey) && row.noHeading === true;
                  // Same "Column N" fallback used at submit, so the date red-border
                  // matches the name actually sent to verifyDateFormatFromCSV.
                  const effectiveName = hasHeading
                    ? row.fieldName
                    : `${NO_HEADING_COLUMN_PREFIX} ${index + 1}`;

                  return (
                    <div key={`match-col-${index}`} className="match-col-main-wrapper-col">
                      <div
                        className={`map-cols-header px-2 ${
                          matched ? "matched-sec-bg" : "unmatched-sec-bg"
                        }`}
                        style={{
                          height: "240px",
                          paddingBottom: "10px",
                          border: wrongDateColumns
                            .map((x) => x.fieldName)
                            .includes(effectiveName)
                            ? "1px solid red"
                            : "",
                        }}
                      >
                        <div className="text-center font-weight-bold mb-2">
                          {showHeadingInput ? (
                            <input
                              key={`heading-input-${index}`}
                              type="text"
                              className="input-no-border"
                              placeholder={NO_HEADING_COLUMN_PLACEHOLDER}
                              value={row.fieldName}
                              onChange={(e) => {
                                const newName = e.target.value;
                                setRowData((prev) =>
                                  prev.map((r, i) =>
                                    i === index ? { ...r, fieldName: newName } : r
                                  )
                                );
                              }}
                            />
                          ) : getFieldNameFromKey(row.selectedKey) ? (
                            getFieldNameFromKey(row.selectedKey)
                          ) : (
                            row.fieldName
                          )}
                        </div>
                        <Select
                          options={fieldOptions.map((o) => ({
                            ...o,
                            // if your react-select needs 'isDisabled' instead of 'disabled', swap it
                            disabled: matchedKeys.includes(o.value),
                          }))}

                          // show the current selection as an option object
                          value={fieldOptions.find((o) => o.value === row.selectedKey) || null}

                          onChange={(opt) => {
                            if (!opt || !opt.value) return;
                            const value = opt.value;

                            // 1) only update this column if the key isn't already used elsewhere
                            setRowData((prev) => {
                              const taken = prev.some((c, i2) => i2 !== index && c.selectedKey === value);
                              if (taken) {
                                toastContainer(
                                  "This column is already matched—please unmatch previous & try again",
                                  "error"
                                );
                                return prev;
                              }
                              const next = [...prev];
                              next[index] = { ...next[index], selectedKey: value, fieldName: value };
                              return next;
                            });

                            // 2) dedupe matchedKeys
                            setmatchedKeys((prev) => (prev.includes(value) ? prev : [...prev, value]));
                          }}
                        />

                        {!matched && (
                          <div className="text-center font-weight-bold my-2">
                            <Checkbox
                              className="ml-0"
                              checked={includedColumns[row.fieldName] === true}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const fieldName = row.fieldName;
                                setIncludedColumns((prev) => ({
                                  ...prev,
                                  [fieldName]: checked,
                                }));
                              }}
                            />
                            Include in upload
                          </div>
                        )}

                        <div className="text-center font-weight-bold my-2">
                          <Checkbox
                            className="ml-0"
                            checked={(function () {
                              const dateEntry = isDateSampleData.find(function (d) {
                                return d && d.fieldName === row.fieldName;
                              });
                              return dateEntry ? dateEntry.isDate : false;
                            })()}
                            onChange={(e) => {
                              handleDateFieldCheck(e, row.fieldName);
                            }}
                          />
                          Date field?
                        </div>

                        <div className="text-center mt-4">
                          {matched ? (
                            <span className="matched-column-txt">
                              (matched column)
                            </span>
                          ) : (
                            <span className="unmatched-column-txt">
                              (unmatched column)
                            </span>
                          )}
                          {matched ? (
                            <div className="text-center mt10">
                              <i
                                className="material-icons"
                                style={{ color: "#1EC4B4", fontSize: "30px" }}
                              >
                                check_circle
                              </i>
                            </div>
                          ) : null}

                          {matched ? (
                            <div className="text-center mt10">
                              <span
                                className="text-danger cursor-pointer"
                                onClick={() => {
                                  const matched = [...matchedKeys].filter(
                                    (x) => x != row.selectedKey
                                  );

                                  if (row.selectedKey == "mobileNumber") {
                                    // setInviteViaSMS(false)
                                    // phoneValuesPresent=false
                                    setPhoneValuesPresent(false);
                                    setInviteViaSMS(false);
                                  }

                                  setmatchedKeys(matched);

                                  // A match overwrote fieldName with the key. For a
                                  // column that originally had no heading, clear it
                                  // back to "" so the editable heading input returns.
                                  setRowData((prev) =>
                                    prev.map((r, i) =>
                                      i === index
                                        ? {
                                            ...r,
                                            selectedKey: "",
                                            fieldName: r.noHeading ? "" : r.fieldName,
                                          }
                                        : r
                                    )
                                  );
                                }}
                              >
                                Unmatch
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      {/* <div className="mt-3">
                        {row.data.map((x) => (
                          <div className="map-cols-data">{x}</div>
                        ))}
                      </div> */}
                      <div className="mt-3">
                        {row.data.slice(0, PREVIEW_LIMIT).map((x, i) => (
                          <div key={i} className="map-cols-data">{x}</div>
                        ))}
                        {row.data.length > PREVIEW_LIMIT && <div>…{row.data.length - PREVIEW_LIMIT} more</div>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : currentStep == 3 && usersList.length ? (
          <div>
            {invalidUsersList && invalidUsersList.length
              ? 
                null
              : ""}
 

            {console.log("old Matched Keys:",!isEqual(oldMatchedKeys, matchedKeys), oldMatchedKeys, "Matched keys:", matchedKeys)}

            { /// !uploadAndUpdate &&
              // matchedKeys &&
              // oldMatchedKeys &&
              // oldMatchedKeys.length &&
              // matchedKeys.length &&
              // !isEqual(oldMatchedKeys, matchedKeys) &&
              missingLabel&&
              missingLabel.length>0&& (
                <Alert color="info">
                   {/* Heads up — last time you used{" "}
                  <b>{formatKeysForDisplay(oldMatchedKeys).join(", ")}</b> as your unique identifier.
                  This time you’ve selected <b>{formatKeysForDisplay(matchedKeys).join(", ")}</b>. That
                  might cause new users to be created even if they already
                  exist. Are you sure you want to proceed? You can change this
                  by going back to the previous screen{" "}  */}
                  <strong>Heads Up:</strong> Your new file is missing the following field(s) that were uploaded last time: <b>{missingLabel.join(', ')}</b>. These will be erased if you proceed with this upload.
                  
                </Alert>
              )}

            <div className="table-responsive" style={{ maxHeight: "450px" }}>
              <Table className="mt-2">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    {isEmailPresent && <th>Email</th>}
                    {usersList[0].hasOwnProperty("employeeId") &&
                    usersList[0].employeeId != undefined ? (
                      <th>Employee ID</th>
                    ) : (
                      ""
                    )}
                    {usersList[0].hasOwnProperty("mobileNumber") &&
                    usersList[0].mobileNumber != undefined ? (
                      <th>Mobile Number</th>
                    ) : (
                      ""
                    )}
                    {usersList[0].hasOwnProperty("departmentPosition") &&
                    usersList[0].departmentPosition != undefined ? (
                      <th>Department/Position</th>
                    ) : (
                      ""
                    )}
                    {rowData
                      .filter(function (r) {
                        const isMatched = r.selectedKey && r.selectedKey !== "";
                        return !isMatched && includedColumns[r.fieldName] === true;
                      })
                      .map(function (r) {
                        return <th key={r.fieldName}>{r.fieldName}</th>;
                      })}
                  </tr>
                </thead>

                {usersList.length ? (
                  <tbody>
                    {usersList.map((x,i) => (
                      <tr key={x.email || x.mobileNumber || x.employeeId || i}>
                        <td>{x.firstName}</td> <td>{x.lastName}</td>{" "}
                        {isEmailPresent && (
                          <td style={{ position: "relative" }}>
                            {x.email}{" "}
                            {x.email && x.isNew && (
                              <span className="new-user-upload-row-item-badge">
                                New
                              </span>
                            )}{" "}
                          </td>
                        )}
                        {usersList[0].hasOwnProperty("employeeId") &&
                        usersList[0].employeeId != undefined ? (
                          <td>{x.employeeId}</td>
                        ) : (
                          ""
                        )}
                        {usersList[0].hasOwnProperty("mobileNumber") &&
                        usersList[0].mobileNumber != undefined ? (
                          <td>{x.mobileNumber}</td>
                        ) : (
                          ""
                        )}
                        {usersList[0].hasOwnProperty("departmentPosition") ? (
                          <td>{x.departmentPosition}</td>
                        ) : (
                          ""
                        )}
                        {rowData
                          .filter(function (r) {
                            const isMatched = r.selectedKey && r.selectedKey !== "";
                            return !isMatched && includedColumns[r.fieldName] === true;
                          })
                          .map(function (r) {
                            return <td key={r.fieldName}>{x[r.fieldName]}</td>;
                          })}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  "No data exists"
                )}
              </Table>
            </div>
          </div>
        ) : null}

        {currentStep == 3 && (
          <div className="py-2 mt-3 d-flex align-items-center uploasSettingBorder">
            <h6 className="">Notify: </h6>

            <span>
              <label className={"ml-2"}>New users only</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="notification"
                value="notifyNewUsers"
                checked={notificationType === "notifyNewUsers"}
                className="ml-0"
                onChange={handleRadioChange}
              />
            </span>

            <span>
              <label className={"ml-4"}>All users (not activated yet)</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="notification"
                value="notifyAllUsers"
                checked={notificationType === "notifyAllUsers"}
                className="ml-0"
                onChange={handleRadioChange}
              />
            </span>

            <span>
              <label className={"ml-4"}>Do not notify</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="notification"
                value=""
                checked={notificationType === ""}
                className="ml-0"
                onChange={handleRadioChange}
              />
            </span>
          </div>
        )}

        {currentStep == 3 && (
          <div className="py-2 mt-3 d-flex align-items-center uploasSettingBorder">
            <h6 className="">Upload settings: </h6>

            {/* <span>
              <label className={"ml-2"}>Upload only</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="uploas"
                value="uploadOnly"
                checked={uploadType === "uploadOnly"}
                className="ml-0"
                onChange={handleRadioChangeForUploadType}
              />
            </span> */}

            <span>
              <label className={"ml-4 mb-0"}>
                Upload and update if user exists
              </label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="upload"
                value="uploadAndUpdate"
                checked={uploadType === "uploadAndUpdate"}
                className="ml-0"
                onChange={handleRadioChangeForUploadType}
              />
              <br />
              <small className="text-secondary ml-4 font-11px">
                (previous user info will be overwritten)
              </small>
            </span>
          </div>
        )}

        {currentStep == 3 && (notifyAllUsers || notifyNewUsers) && (
          <div className="py-2 d-flex align-items-center uploasSettingBorder">
            <h6>Via: </h6>

            <span>
              <Label className={"ml-2"}>Email</Label>{" "}
              <Checkbox
                className="ml-0"
                checked={inviteViaEmail}
                disabled={!emailValuesPresent}
                onChange={(e) => setInviteViaEmail(e.target.checked)}
              />
            </span>

            <span
              style={{
                opacity: phoneValuesPresent ? "1" : "0.5",
              }}
            >
              <Label className={"ml-4"}>SMS text</Label>{" "}
              <Checkbox
                className="ml-0"
                disabled={!phoneValuesPresent}
                checked={phoneValuesPresent ? inviteViaSMS : false}
                onChange={(e) => setInviteViaSMS(e.target.checked)}
              />
            </span>

            {!inviteViaEmail && !inviteViaSMS ? (
              <Label className="notify-via-msg">(select at least one) </Label>
            ) : null}
          </div>
        )}

        {currentStep == 3 && (
          <div className="mt-4 upload-deactivate-row">
            <Checkbox
              checked={deactivateOldNonCsvUsers}
              onChange={(e) => setDeactivateOldNonCsvUsers(e.target.checked)}
            />{" "}
            <Label>
              Deactivate users if they do not exists in uploaded csv?
            </Label>
            {deactivateOldNonCsvUsers && (loadingOldUsers || oldUsersError) && (
              <div className="text-muted mt-1">
                <small>
                  {oldUsersError
                    ? "Couldn't load the current user list — reopen the upload to retry before deactivating."
                    : "Loading current users to calculate the count…"}
                </small>
              </div>
            )}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          style={{ height: "35px" }}
          className=""
          onClick={() => {
            if (currentStep == 1) {
              onClose();
            } else {
              setCurrentStep(currentStep - 1);
            }
          }}
        >
          {currentStep == 1 ? "Cancel" : "Back"}
        </Button>

        {currentStep == 3 && (
          <div className="uploadUserWarningText">{getWarningText()}</div>
        )}

        {/* <Button
          style={{ height: "35px" }}
          className="mr-3 ml-3"
          onClick={() => {
            if (currentStep == 1) {
              onClose();
            } else {
              setCurrentStep(currentStep - 1);
            }
          }}
        >
          {currentStep == 1 ? "Cancel" : "Go Back"}
        </Button> */}

        <Button
          className="trivia-action-button-main mr-0"
          style={{ height: "35px" }}
          disabled={buttonDisabled() || (currentStep == 3 && deactivateOldNonCsvUsers && (loadingOldUsers || oldUsersError))}
          onClick={() => {
            if (currentStep == 1) {
              setCurrentStep(currentStep + 1);
            } else if (currentStep == 2) {
              mapTableData();
            } else if (deactivateOldNonCsvUsers && deactivateCount > 0) {
              setShowDeactivateConfirm(true);
            } else {
              handleUploadUsers();
            }
          }}
          // color="success"
        >
          {currentStep == 3 ? "Upload" : "Continue"}
        </Button>
      </ModalFooter>

      <WarningModal
        open={showDeactivateConfirm}
        message={DEACTIVATE_USERS_CONFIRMATION(deactivateCount)}
        onOk={() => {
          setShowDeactivateConfirm(false);
          handleUploadUsers();
        }}
        onCancel={() => setShowDeactivateConfirm(false)}
        onClose={() => setShowDeactivateConfirm(false)}
      />
    </Modal>
  );
}
